// extracted by mini-css-extract-plugin
export var entries = "MobileNavigation-module--entries---mhmW";